import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: #f5f5f5;
	width: 100%;
	padding-top: 60px;
`;

export const HeadingLowerFont = styled.p`
	margin: 0;
	text-align: center;
	font-size: 12px;
	color: #525252;
	padding: 0 16px;
`;

export const HeadingFont = styled.p`
	margin: 0;
	text-align: center;
	line-height: 1.2;
	font-size: 22px;
	font-weight: 900;
	padding: 0 16px;
`;

export const ContentContainer = styled.div`
	width: 98%;
	margin: 0 auto;
	position: relative;
	padding: 40px 0;
	padding-bottom: 60px;
`;

export const CardsContainer = styled.div`
	display: flex;
	justify-content: center;
	@media screen and (max-width: 800px) {
		flex-flow: column nowrap;
		align-items: center;
	}
`;

export const Card = styled.div`
	width: 400px;
	height: 650px;
	margin: 0 15px;
	border: 2px solid #1e7aab;
	border-radius: 10px;
	padding: 5px;
	position: relative;
	z-index: 99;
	background-color: #fff;
	p {
		font-family: Montserrant;
		font-size: 12px;
		line-height: 1.4;
		margin: 20px;
	}
	a {
		color: #000;
	}
	li {
		font-size: 12px;
		margin-right: 20px;
	}
	li::marker {
		color: #1e7aab;
		font-size: 20px;
	}
	p span,
	li span {
		font-family: Montserrant-Bold;
	}
	@media screen and (max-width: 800px) {
		margin: 0 auto 30px;
	}
	@media screen and (max-width: 410px) {
		width: 98%;
		height: auto;
		&:first-child {
			padding-bottom: 150px;
		}
		&:nth-child(2) {
			padding-bottom: 50px;
		}
	}
`;

export const CardHeadingContainer = styled.div`
	width: 100%;
	background-image: linear-gradient(45deg, #014587, #0f7cc4);
	border-radius: 7px 7px 0 0;
	padding-left: 16px;
	padding-top: 30px;
	padding-bottom: 30px;
	p {
		margin: 0;
		color: #fff;
		font-family: Montserrant;
	}
	& > p:nth-child(1) {
		font-size: 18px;
		font-family: Montserrant-Bold;
	}
	& > p:nth-child(2) {
		font-size: 11px;
	}
`;

export const CardHeadingEmailContainer = styled.div`
	display: flex;
	align-items: center;
	/* margin-top: 20px; */
	/* div {
		background-color: #f8f971;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
	}
	svg {
		width: 25px;
		height: 25px;
		fill: #014587;
	}
	p {
		color: #fff;
		font-size: 16px;
		font-family: Montserrant-Black;
		margin-left: 12px;
	} */
`;

export const CardDivider = styled.div`
	width: 95%;
	height: 1px;
	margin: 4px auto;
	background-color: #e9e9e9;
`;

export const CardDownloadSection = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: calc(100% - 10px);
	height: 150px;
	position: absolute;
	bottom: 5px;
	left: 50%;
	transform: translateX(-50%);
	border-radius: 0 0 7px 7px;
	background-image: linear-gradient(
		135deg,
		#e7e7e7 25%,
		#f3f3f3 25%,
		#f3f3f3 50%,
		#e7e7e7 50%,
		#e7e7e7 75%,
		#f3f3f3 75%,
		#f3f3f3 100%
	);
	background-size: 5.5px 5.5px;
`;

export const CardDownloadButton = styled.div`
	width: 145px;
	height: 110px;
	margin: 0 10px;
	border-radius: 8px;
	background-color: #fff;
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	user-select: none;
	svg {
		width: 30px;
		height: 30px;
		margin-bottom: 8px;
	}
	p {
		margin: 2px 0;
		font-size: 10px;
		text-align: center;
		padding: 0 16px;
	}
	&:nth-child(1) {
		border: 2px solid #da8173;
		svg {
			fill: #da8173;
		}
	}
	&:nth-child(2) {
		border: 2px solid #29365c;
		svg {
			fill: #29365c;
		}
	}
`;

export const CardListFont = styled.p`
	margin: 0 !important;
	margin-left: 20px !important;
`;

export const CardListImportantFont = styled.p`
	color: #f19182;
	font-family: Montserrant-Black !important;
	font-size: 14px !important;
	margin-bottom: -10px !important;
`;

export const CardsContainerBackgroundDecor = styled.div`
	background: linear-gradient(135deg, #e5e5e5 25%, transparent 25%),
		linear-gradient(225deg, #e5e5e5 25%, transparent 25%),
		linear-gradient(315deg, #e5e5e5 25%, transparent 25%),
		linear-gradient(45deg, #e5e5e5 25%, transparent 25%);
	background-size: 8px 8px;
	background-color: #f4f4f4;
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 600px;
	@media screen and (max-width: 800px) {
		height: 90%;
	}
`;
